var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useReducer, useEffect, useCallback } from 'react';
import reducer, { initState } from './reducers';
import actions from './actions';
import { ApiProvider, useApi } from '@cmr/react-api-hook';
import { compare } from 'fast-json-patch';
export var ClientsContext = React.createContext(null);
export var useClients = function () { return useContext(ClientsContext); };
var endpoints = {
    test: 'https://infinity-clients-test.azurewebsites.net/',
    prod: 'https://infinity-clients.azurewebsites.net/',
    dev: 'http://localhost:7071/'
};
var ClientsProviderComponent = function (_a) {
    var children = _a.children, endpoint = _a.endpoint, loadOnInit = _a.loadOnInit;
    var _b = useReducer(reducer, initState), state = _b[0], dispatch = _b[1];
    var _c = useApi(), apiFetch = _c.apiFetch, authReady = _c.authReady;
    var apiEndpoint = (endpoints[endpoint] || endpoint) + "clients";
    var save = function (client) { return __awaiter(void 0, void 0, void 0, function () {
        var origClient, patch;
        return __generator(this, function (_a) {
            origClient = state.clients.find(function (cl) { return cl.id === client.id; });
            if (!origClient)
                throw new Error('Client not found');
            patch = compare(origClient, client);
            return [2 /*return*/, apiFetch(apiEndpoint + "/" + (origClient.referenceName || origClient.name), dispatch, actions.save, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(patch)
                })];
        });
    }); };
    var fetch = useCallback(function () {
        if (!authReady)
            return new Promise(function () { return null; });
        return apiFetch(apiEndpoint, dispatch, actions.fetch);
    }, [apiFetch, authReady]);
    useEffect(function () {
        if (!authReady || !loadOnInit)
            return;
        apiFetch(apiEndpoint, dispatch, actions.fetch);
    }, [apiFetch, authReady]);
    return (React.createElement(ClientsContext.Provider, { value: __assign(__assign({}, state), { save: save, fetch: fetch }) }, children));
};
export var ClientsProvider = function (props) { return (React.createElement(ApiProvider, null,
    React.createElement(ClientsProviderComponent, __assign({}, props)))); };
//# sourceMappingURL=context.js.map